/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Footer.css';
import Link from '../Link';

class Footer extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.navigation}>
            <p className={s.copyright}>
              © 2026 Holger Sindbaek. All rights reserved.
            </p>
            <Link className={s.link} to="/contact">
              Contact
            </Link>
            <Link className={s.link} to="/privacy-policy">
              Privacy policy
            </Link>
            <Link className={s.link} to="/terms-of-use">
              Terms of use
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);
